var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNewjersey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.15,
    height: 183.887,
    viewBox: "0 0 94.15 183.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__icon_newjersey"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_360",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 360",
    transform: "translate(44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_361",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 361",
    transform: "translate(38.432 6.436)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_362",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 362",
    transform: "translate(44.868 6.436)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_363",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 363",
    transform: "translate(51.304 6.436)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_364",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 364",
    transform: "translate(38.432 12.872)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_365",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 365",
    transform: "translate(44.868 12.872)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_366",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 366",
    transform: "translate(51.304 12.872)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_367",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 367",
    transform: "translate(57.74 12.872)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_368",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 368",
    transform: "translate(64.176 12.872)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_369",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 369",
    transform: "translate(31.996 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_370",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 370",
    transform: "translate(38.432 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_371",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 371",
    transform: "translate(44.868 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_372",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 372",
    transform: "translate(51.304 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_373",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 373",
    transform: "translate(57.74 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_374",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 374",
    transform: "translate(64.176 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_375",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 375",
    transform: "translate(70.428 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_376",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 376",
    transform: "translate(76.864 19.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_377",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 377",
    transform: "translate(25.56 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_378",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 378",
    transform: "translate(31.996 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_379",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 379",
    transform: "translate(38.432 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_380",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 380",
    transform: "translate(44.868 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_381",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 381",
    transform: "translate(51.304 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_382",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 382",
    transform: "translate(57.74 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_383",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 383",
    transform: "translate(64.176 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_384",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 384",
    transform: "translate(70.428 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_385",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 385",
    transform: "translate(76.864 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_386",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 386",
    transform: "translate(83.3 25.744)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_387",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 387",
    transform: "translate(25.56 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_388",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 388",
    transform: "translate(31.996 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_389",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 389",
    transform: "translate(38.432 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_390",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 390",
    transform: "translate(44.868 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_391",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 391",
    transform: "translate(51.304 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_392",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 392",
    transform: "translate(57.74 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_393",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 393",
    transform: "translate(64.176 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_394",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 394",
    transform: "translate(70.428 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_395",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 395",
    transform: "translate(76.864 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_396",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 396",
    transform: "translate(83.3 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_397",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 397",
    transform: "translate(89.736 31.996)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_398",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 398",
    transform: "translate(25.56 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_399",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 399",
    transform: "translate(31.996 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_400",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 400",
    transform: "translate(38.432 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_401",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 401",
    transform: "translate(44.868 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_402",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 402",
    transform: "translate(51.304 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_403",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 403",
    transform: "translate(57.74 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_404",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 404",
    transform: "translate(64.176 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_405",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 405",
    transform: "translate(70.428 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_406",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 406",
    transform: "translate(76.864 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_407",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 407",
    transform: "translate(83.3 38.432)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_408",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 408",
    transform: "translate(19.308 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_409",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 409",
    transform: "translate(25.56 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_410",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 410",
    transform: "translate(31.996 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_411",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 411",
    transform: "translate(38.432 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_412",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 412",
    transform: "translate(44.868 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_413",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 413",
    transform: "translate(51.304 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_414",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 414",
    transform: "translate(57.74 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_415",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 415",
    transform: "translate(64.176 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_416",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 416",
    transform: "translate(70.428 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_417",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 417",
    transform: "translate(76.864 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_418",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 418",
    transform: "translate(83.3 44.868)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_419",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 419",
    transform: "translate(19.308 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_420",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 420",
    transform: "translate(25.56 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_421",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 421",
    transform: "translate(31.996 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_422",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 422",
    transform: "translate(38.432 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_423",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 423",
    transform: "translate(44.868 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_424",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 424",
    transform: "translate(51.304 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_425",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 425",
    transform: "translate(57.74 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_426",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 426",
    transform: "translate(64.176 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_427",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 427",
    transform: "translate(70.428 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_428",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 428",
    transform: "translate(76.864 51.304)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_429",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 429",
    transform: "translate(19.308 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_430",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 430",
    transform: "translate(25.56 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_431",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 431",
    transform: "translate(31.996 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_432",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 432",
    transform: "translate(38.432 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_433",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 433",
    transform: "translate(44.868 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_434",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 434",
    transform: "translate(51.304 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_435",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 435",
    transform: "translate(57.74 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_436",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 436",
    transform: "translate(64.176 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_437",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 437",
    transform: "translate(70.428 57.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_438",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 438",
    transform: "translate(25.56 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_439",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 439",
    transform: "translate(31.996 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_440",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 440",
    transform: "translate(38.432 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_441",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 441",
    transform: "translate(44.868 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_442",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 442",
    transform: "translate(51.304 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_443",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 443",
    transform: "translate(57.74 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_444",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 444",
    transform: "translate(64.176 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_445",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 445",
    transform: "translate(70.428 64.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_446",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 446",
    transform: "translate(25.56 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_447",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 447",
    transform: "translate(31.996 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_448",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 448",
    transform: "translate(38.432 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_449",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 449",
    transform: "translate(44.868 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_450",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 450",
    transform: "translate(51.304 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_451",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 451",
    transform: "translate(57.74 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_452",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 452",
    transform: "translate(64.176 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_453",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 453",
    transform: "translate(70.428 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_454",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 454",
    transform: "translate(76.864 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_455",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 455",
    transform: "translate(83.3 70.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_456",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 456",
    transform: "translate(38.432 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_457",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 457",
    transform: "translate(44.868 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_458",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 458",
    transform: "translate(51.304 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_459",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 459",
    transform: "translate(57.74 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_460",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 460",
    transform: "translate(64.176 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_461",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 461",
    transform: "translate(70.428 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_462",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 462",
    transform: "translate(76.864 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_463",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 463",
    transform: "translate(83.3 76.865)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_464",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 464",
    transform: "translate(38.432 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_465",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 465",
    transform: "translate(44.868 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_466",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 466",
    transform: "translate(51.304 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_467",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 467",
    transform: "translate(57.74 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_468",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 468",
    transform: "translate(64.176 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_469",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 469",
    transform: "translate(70.428 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_470",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 470",
    transform: "translate(76.864 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_471",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 471",
    transform: "translate(83.3 83.301)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_472",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 472",
    transform: "translate(44.868 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_473",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 473",
    transform: "translate(51.304 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_474",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 474",
    transform: "translate(57.74 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_475",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 475",
    transform: "translate(64.176 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_476",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 476",
    transform: "translate(70.428 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_477",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 477",
    transform: "translate(76.864 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_478",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 478",
    transform: "translate(83.3 89.737)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_479",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 479",
    transform: "translate(31.996 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_480",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 480",
    transform: "translate(38.432 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_481",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 481",
    transform: "translate(44.868 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_482",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 482",
    transform: "translate(51.304 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_483",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 483",
    transform: "translate(57.74 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_484",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 484",
    transform: "translate(64.176 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_485",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 485",
    transform: "translate(70.428 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_486",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 486",
    transform: "translate(76.864 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_487",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 487",
    transform: "translate(83.3 96.173)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_488",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 488",
    transform: "translate(25.56 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_489",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 489",
    transform: "translate(31.996 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_490",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 490",
    transform: "translate(38.432 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_491",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 491",
    transform: "translate(44.868 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_492",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 492",
    transform: "translate(51.304 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_493",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 493",
    transform: "translate(57.74 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_494",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 494",
    transform: "translate(64.176 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_495",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 495",
    transform: "translate(70.428 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_496",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 496",
    transform: "translate(76.864 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_497",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 497",
    transform: "translate(83.3 102.609)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_498",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 498",
    transform: "translate(25.56 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_499",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 499",
    transform: "translate(31.996 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_500",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 500",
    transform: "translate(38.432 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_501",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 501",
    transform: "translate(44.868 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_502",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 502",
    transform: "translate(51.304 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_503",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 503",
    transform: "translate(57.74 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_504",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 504",
    transform: "translate(64.176 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_505",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 505",
    transform: "translate(70.428 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_506",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 506",
    transform: "translate(76.864 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_507",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 507",
    transform: "translate(83.3 109.045)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_508",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 508",
    transform: "translate(6.436 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_509",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 509",
    transform: "translate(12.872 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_510",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 510",
    transform: "translate(19.308 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_511",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 511",
    transform: "translate(25.56 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_512",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 512",
    transform: "translate(31.996 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_513",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 513",
    transform: "translate(38.432 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_514",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 514",
    transform: "translate(44.868 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_515",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 515",
    transform: "translate(51.304 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_516",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 516",
    transform: "translate(57.74 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_517",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 517",
    transform: "translate(64.176 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_518",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 518",
    transform: "translate(70.428 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_519",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 519",
    transform: "translate(76.864 115.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_520",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 520",
    transform: "translate(6.436 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_521",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 521",
    transform: "translate(12.872 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_522",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 522",
    transform: "translate(19.308 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_523",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 523",
    transform: "translate(25.56 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_524",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 524",
    transform: "translate(31.996 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_525",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 525",
    transform: "translate(38.432 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_526",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 526",
    transform: "translate(44.868 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_527",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 527",
    transform: "translate(51.304 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_528",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 528",
    transform: "translate(57.74 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_529",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 529",
    transform: "translate(64.176 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_530",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 530",
    transform: "translate(70.428 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_531",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 531",
    transform: "translate(76.864 121.733)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_532",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 532",
    transform: "translate(0 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_533",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 533",
    transform: "translate(6.436 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_534",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 534",
    transform: "translate(12.872 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_535",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 535",
    transform: "translate(19.308 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_536",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 536",
    transform: "translate(25.56 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_537",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 537",
    transform: "translate(31.996 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_538",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 538",
    transform: "translate(38.432 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_539",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 539",
    transform: "translate(44.868 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_540",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 540",
    transform: "translate(51.304 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_541",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 541",
    transform: "translate(57.74 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_542",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 542",
    transform: "translate(64.176 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_543",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 543",
    transform: "translate(70.428 128.169)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_544",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 544",
    transform: "translate(0 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_545",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 545",
    transform: "translate(6.436 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_546",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 546",
    transform: "translate(12.872 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_547",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 547",
    transform: "translate(19.308 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_548",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 548",
    transform: "translate(25.56 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_549",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 549",
    transform: "translate(31.996 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_550",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 550",
    transform: "translate(38.432 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_551",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 551",
    transform: "translate(44.868 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_552",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 552",
    transform: "translate(51.304 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_553",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 553",
    transform: "translate(57.74 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_554",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 554",
    transform: "translate(64.176 134.605)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_555",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 555",
    transform: "translate(0 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_556",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 556",
    transform: "translate(6.436 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_557",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 557",
    transform: "translate(12.872 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_558",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 558",
    transform: "translate(19.308 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_559",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 559",
    transform: "translate(25.56 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_560",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 560",
    transform: "translate(31.996 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_561",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 561",
    transform: "translate(38.432 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_562",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 562",
    transform: "translate(44.868 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_563",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 563",
    transform: "translate(51.304 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_564",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 564",
    transform: "translate(57.74 141.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_565",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 565",
    transform: "translate(6.436 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_566",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 566",
    transform: "translate(12.872 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_567",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 567",
    transform: "translate(19.308 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_568",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 568",
    transform: "translate(25.56 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_569",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 569",
    transform: "translate(31.996 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_570",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 570",
    transform: "translate(38.432 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_571",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 571",
    transform: "translate(44.868 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_572",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 572",
    transform: "translate(51.304 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_573",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 573",
    transform: "translate(57.74 147.477)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_574",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 574",
    transform: "translate(12.872 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_575",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 575",
    transform: "translate(19.308 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_576",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 576",
    transform: "translate(25.56 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_577",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 577",
    transform: "translate(31.996 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_578",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 578",
    transform: "translate(38.432 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_579",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 579",
    transform: "translate(44.868 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_580",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 580",
    transform: "translate(51.304 153.729)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_581",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 581",
    transform: "translate(25.56 160.165)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_582",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 582",
    transform: "translate(31.996 160.165)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_583",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 583",
    transform: "translate(38.432 160.165)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_584",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 584",
    transform: "translate(44.868 160.165)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_585",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 585",
    transform: "translate(38.432 166.601)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_586",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 586",
    transform: "translate(44.868 166.601)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_587",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 587",
    transform: "translate(31.996 173.037)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_588",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 588",
    transform: "translate(38.432 173.037)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_589",
    cx: 2.207,
    cy: 2.207,
    r: 2.207,
    className: "prefix__cls-1",
    "data-name": "Ellipse 589",
    transform: "translate(31.996 179.473)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewjersey);
export default __webpack_public_path__ + "static/media/icon-newjersey.a0782b26dbb9491872b17ae2f60c0d42.svg";
export { ForwardRef as ReactComponent };